import React, { useState, useEffect } from "react";
import { getFormatDate } from "service/format-date";
import ControlButtons from "items/control-buttons/control-buttons";
import s from "./report.module.scss";

const Report = (props) => {

    const [item, setItem] = useState(props.item ? props.item : null);
    const [controlButtons, setControlButtons] = useState(props.controlButtons);

    useEffect(() => {
        setItem(props.item ? props.item : null);
        setControlButtons(props.controlButtons);
    }, [props]);

    const onButtobClick = (type) => {
        switch(type){
            case 'edit':
                setTimeout(() => {props.setIsReadOnly(false)}, 100);
                break;
            case 'copy':
                props.copyTemplate(item, props.getValue("COPY_OF"));
                props.setIsReadOnly(true);
                break;
            case 'show':
                props.setIsReadOnly(true);
                break;
            case 'delete':
                props.deleteReportTemplate(item.id);
                setSelectedReport(null);
                break;
        }
    }

    const setSelectedReport = (reportId) => {
        props.setSelectedReportId(reportId);
    }

    return (
        <div className={props.selectedReport === item.id ? s.selectedReport+ " " + s.Report : s.Report} onClick={setSelectedReport.bind(this, item.id)}>
            <span className={s.templateName}>{item.name}</span>
            <div className={s.reportBlock}>
                <div className={s.reportDates}>
                    <div className={s.reportDate}>
                        <span>{getFormatDate(item.createdAt, 'DD-MM-YY, HH:MM')}</span>
                    </div>
                    <div className={s.reportDate}>
                        <span>{getFormatDate(item.updatedAt, 'DD-MM-YY, HH:MM')}</span>
                    </div>
                    
                </div>
                <div className={s.reportTopicName}>
                    <span className={s.topicTitile}>{ props.getValue('TOPIC')+':' }</span>
                    <span>{ props.getTopicName(props.item.uuid)}</span>
                </div>               
            </div>
            <div className={s.controllButtons}>
                    <ControlButtons keyId={1} callback={onButtobClick} status={'ACTIVE'} items={props.controlButtons} index={1} isSubtopic={false}/>
                </div>

        </div>
    )
}

export default Report;